"use strict";

angular.module("core")
.component("bulkAction", {
    templateUrl: require("./bulk-action.component.html"),
    controller: BulkActionController,
    controllerAs: "bulkActionCtrl",
    bindings: {
        service: "<",
        referenceId: "<?",
        refreshFunction: "&?"
    }
});

function BulkActionController($rootScope, $scope, ModalService, ActionFactory) {
    var _this = this;
    var actionService = new ActionFactory(this.service);

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        updateBulkActionParams();
    });

    this.$onDestroy = function() {
        unregisterLanguageChanged();
    };

    this.submit = function() {
        this.isSubmitted = true;
        if (!_this.isValid()) {
            return;
        }

        actionService.submitBulkAction(this.action, this.referenceId).then(function onSuccess() {
            if (_this.refreshFunction) {
                _this.refreshFunction();
            }
            $scope.$emit("queryListing");
            _this.isSubmitted = false;
            _this.action = "";
        });
    };


    this.isValid = function() {
        return !this.isSubmitted || this.action;
    };

    function updateBulkActionParams() {
        $scope.bulkActionParams = _this.service.getBulkActionParams();
    }

    updateBulkActionParams();

}



//////////////////
// WEBPACK FOOTER
// ./core/action/bulk-action.component.js
// module id = 585
// module chunks = 0